import { Pipe } from '@angular/core';
import { isUndefined } from '../helpers/helpers';
var IsDefinedPipe = (function () {
    function IsDefinedPipe() {
    }
    IsDefinedPipe.prototype.transform = function (input) {
        return !isUndefined(input);
    };
    IsDefinedPipe.decorators = [
        { type: Pipe, args: [{ name: 'isDefined' },] },
    ];
    /** @nocollapse */
    IsDefinedPipe.ctorParameters = function () { return []; };
    return IsDefinedPipe;
}());
export { IsDefinedPipe };
//# sourceMappingURL=is-defined.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/boolean/is-defined.js
// module id = 241
// module chunks = 4